/**
 * Fallback: Comprar agora / sticky = adicionar ao carrinho quando vestfirma-pdp.js não iniciou.
 */
(function () {
  'use strict';

  function cartAddFailed(data) {
    if (!data || typeof data !== 'object') return false;
    if (data.status === 'error') return true;
    var st = Number(data.status);
    if (!Number.isNaN(st) && st >= 400) return true;
    return Boolean(data.description);
  }

  function getPdpRoot() {
    return document.querySelector('[data-md-pdp]');
  }

  function promptWholesaleSelection(root) {
    var wholesale = root && root.querySelector('vestfirma-pdp-wholesale');
    if (wholesale && typeof wholesale.promptMissingSelection === 'function') {
      wholesale.promptMissingSelection();
      return;
    }
    window.alert(
      (root && root.dataset.cartAddError) ||
        'Selecione cor, tamanho e quantidade antes de adicionar ao carrinho.'
    );
  }

  function triggerWholesaleSubmit(root) {
    var submit = root.querySelector('[data-vf-submit]');
    if (!submit || submit.disabled || submit.classList.contains('is-busy')) return false;
    submit.click();
    return true;
  }

  function addVariantToCart(root, btn) {
    var form = root.querySelector('[data-md-product-form]');
    var input = form && form.querySelector('[name="id"]');
    if (!input || !input.value) {
      window.alert(
        root.dataset.cartAddError || 'Selecione cor e tamanho antes de adicionar ao carrinho.'
      );
      return;
    }

    if (btn) {
      btn.dataset.mdSubmitting = 'true';
      btn.classList.add('md-pdp__btn--busy');
      btn.setAttribute('aria-busy', 'true');
    }

    var item = { id: Number(input.value), quantity: 1 };
    var sections =
      window.VestfirmaCartAfterAdd && typeof window.VestfirmaCartAfterAdd.getCartSectionIds === 'function'
        ? window.VestfirmaCartAfterAdd.getCartSectionIds()
        : '';
    var payload = { items: [item] };
    if (sections) payload.sections = sections;

    fetch((window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { res: res, data: data };
        });
      })
      .then(function (result) {
        if (!result.res.ok || cartAddFailed(result.data)) {
          var msg =
            (result.data && (result.data.description || result.data.message)) ||
            root.dataset.cartAddError ||
            'Não foi possível adicionar ao carrinho.';
          throw new Error(msg);
        }

        var afterAdd = window.VestfirmaCartAfterAdd;
        if (afterAdd && typeof afterAdd.notifyCartAddAndOpen === 'function') {
          afterAdd.notifyCartAddAndOpen(result.data, 'vestfirma-pdp-buy-now-fallback', {
            source: 'vestfirma-pdp-buy-now-fallback',
            productId: root.dataset.productId,
            sections: result.data.sections,
          });
        }
      })
      .catch(function (err) {
        window.alert(err && err.message ? err.message : String(err));
      })
      .finally(function () {
        if (!btn) return;
        delete btn.dataset.mdSubmitting;
        btn.classList.remove('md-pdp__btn--busy');
        btn.removeAttribute('aria-busy');
      });
  }

  function onBuyClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-md-buy-now], [data-md-sticky-buy-now]');
    if (!btn) return;

    var root = getPdpRoot();
    if (!root) return;

    if (root._vestfirmaPdp) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (btn.disabled || btn.dataset.mdSubmitting === 'true') return;

    if (root.dataset.pdpWholesale === 'true') {
      if (!triggerWholesaleSubmit(root)) {
        promptWholesaleSelection(root);
      }
      return;
    }

    if (window.VestfirmaCheckoutGo && typeof window.VestfirmaCheckoutGo.addItemsToCart === 'function') {
      var form = root.querySelector('[data-md-product-form]');
      var input = form && form.querySelector('[name="id"]');
      if (!input || !input.value) {
        window.alert(root.dataset.cartAddError || 'Selecione a variante antes de adicionar ao carrinho.');
        return;
      }
      btn.dataset.mdSubmitting = 'true';
      window.VestfirmaCheckoutGo.addItemsToCart([{ id: Number(input.value), quantity: 1 }], {
        productId: root.dataset.productId || '',
        errorMessage: root.dataset.cartAddError,
      })
        .catch(function (err) {
          window.alert(err && err.message ? err.message : String(err));
        })
        .finally(function () {
          delete btn.dataset.mdSubmitting;
        });
      return;
    }

    addVariantToCart(root, btn);
  }

  document.addEventListener('click', onBuyClick, true);
})();
